import { getOptimizelyFlags } from '../api/getOptimizelyFlagsApi';
import { updateFeatureFlags } from '../app/store/OptimizelyFlags/OptimizelyFlagsSlice';
import { store } from '../app/store/store';
import { OptimizelyFlags } from '../types/type';

export async function initiateOptimizelyFeatureFlagsCall(urlKey: string, sessionId: string, autKey: string) {
  const optimizelyFeatureFlagResponse = await getOptimizelyFlags(urlKey, sessionId, autKey);

  if (optimizelyFeatureFlagResponse) {
    updateFeatureFlagState(optimizelyFeatureFlagResponse);
  }
  return optimizelyFeatureFlagResponse;
}

function updateFeatureFlagState(optimizelyFeatureFlagResponse: OptimizelyFlags) {
  store.dispatch(
    updateFeatureFlags({
      OptimizelyResponse: optimizelyFeatureFlagResponse,
    })
  );
}
